
import { get } from 'lodash'

export default {
  name: 'Form',

  data() {
    return {
      submissionAttempted: false
    }
  },

  methods: {
    async isFormValid() {
      const isValid = await this.$refs.observer.validate()

      return isValid
    },

    async submit() {
      this.submissionAttempted = true

      const isValid = await this.isFormValid()

      if (!isValid) {
        // If we have a form error report component active let's scroll it in to view
        if (document.querySelector('.form-error-report')) {
          this.$scroll.intoViewIfNeeded(document.querySelector('.form-error-report'))
        }

        // We don't often use the emitted event as we pass formValidation as a prop
        // for displaying inline errors, but we emit the errors here anyway in case it's useful
        // in future to trigger a method or something on the parent
        this.$emit('validationFailed', get(this.$refs, 'observer.ctx.errors'))

        return false
      }

      this.$emit('submit')
    },

    clearErrors() {
      this.$refs.observer.reset()
    }
  }
}
